import { put } from 'redux-saga/effects';

import { InsighttNotification } from '../../helpers/insightt-notification';
import { TIME_CLOCK_TYPES } from '../../constants/app.constants';
import ShiftDetailsActions from '../actions/shift-details.actions';

export function* getShiftDetailsRequest(api, action) {
  const { shiftId } = action;
  const response = yield api.getShiftDetails(shiftId);
  if (response && response.ok) {
    yield put(ShiftDetailsActions.getShiftDetailsSuccess(response.data));
  } else {
    yield put(ShiftDetailsActions.getShiftDetailsFailure());
  }
}

export function* createTimeClockRequest(api, action) {
  const { shiftId, payload } = action;
  const response = yield api.createTimeClock(shiftId, payload);
  if (response && response.ok) {
    yield put(ShiftDetailsActions.createTimeClockSuccess(response.data));
    InsighttNotification(
      'success',
      `New ${payload.type === TIME_CLOCK_TYPES.break ? 'Break' : 'Activity Tracker'} was created successfully`,
      response,
    );
  } else {
    InsighttNotification(
      'error',
      `Unable to create New ${payload.type === TIME_CLOCK_TYPES.break ? 'Break' : 'Activity Tracker'}`,
      response,
    );
    yield put(ShiftDetailsActions.createTimeClockFailure());
  }
}

export function* updateTimeClockRequest(api, action) {
  const { shiftId, timeClockId, payload } = action;
  const response = yield api.updateTimeClock(shiftId, timeClockId, payload);
  if (response && response.ok) {
    yield put(ShiftDetailsActions.updateTimeClockSuccess(response.data));
    InsighttNotification(
      'success',
      `${payload.type === TIME_CLOCK_TYPES.break ? 'Break' : 'Activity Tracker'} was updated successfully`,
      response,
    );
  } else {
    InsighttNotification(
      'error',
      `Unable to update the ${payload.type === TIME_CLOCK_TYPES.break ? 'Break' : 'Activity Tracker'}`,
      response,
    );
    yield put(ShiftDetailsActions.updateTimeClockFailure(timeClockId));
  }
}

export function* deleteTimeClockRequest(api, action) {
  const { shiftId, timeClockId, timeClockType } = action;
  const response = yield api.deleteTimeClock(shiftId, timeClockId);
  if (response && response.ok) {
    yield put(ShiftDetailsActions.deleteTimeClockSuccess(timeClockId, timeClockType));
    InsighttNotification(
      'success',
      `${timeClockType === TIME_CLOCK_TYPES.break ? 'Break' : 'Activity Tracker'} was deleted successfully`,
      response,
    );
  } else {
    InsighttNotification(
      'error',
      `Unable to delete the ${timeClockType === TIME_CLOCK_TYPES.break ? 'Break' : 'Activity Tracker'}`,
      response,
    );
    yield put(ShiftDetailsActions.deleteTimeClockFailure(timeClockId));
  }
}

export function* createIndividualCommissionsRequest(api, action) {
  const { shiftId, payload } = action;
  const response = yield api.createIndividualCommissions(shiftId, payload);
  if (response && response.ok) {
    yield put(ShiftDetailsActions.createIndividualCommissionsSuccess(response.data));
    InsighttNotification('success', 'Individual Bonus was created successfully', response);
  } else {
    InsighttNotification('error', 'Unable to create Individual Bonus', response);
    yield put(ShiftDetailsActions.createIndividualCommissionsFailure());
  }
}

export function* updateIndividualCommissionsRequest(api, action) {
  const { shiftId, payload } = action;
  const response = yield api.updateIndividualCommissions(shiftId, payload);
  if (response && response.ok) {
    yield put(ShiftDetailsActions.updateIndividualCommissionsSuccess(response.data));
    InsighttNotification('success', 'Individual Bonus was updated successfully', response);
  } else {
    InsighttNotification('error', 'Unable to update Individual Bonus', response);
    yield put(ShiftDetailsActions.updateIndividualCommissionsFailure());
  }
}

export function* deleteIndividualCommissionsRequest(api, action) {
  const { shiftId } = action;
  const response = yield api.deleteIndividualCommissions(shiftId);
  if (response && response.ok) {
    yield put(ShiftDetailsActions.deleteIndividualCommissionsSuccess());
    InsighttNotification('success', 'Individual Bonus was removed successfully', response);
  } else {
    InsighttNotification('error', 'Unable to remove Individual Bonus', response);
    yield put(ShiftDetailsActions.deleteIndividualCommissionsFailure());
  }
}

export function* createTeamCommissionsRequest(api, action) {
  const { shiftId, payload } = action;
  const response = yield api.createTeamCommissions(shiftId, payload);
  if (response && response.ok) {
    yield put(ShiftDetailsActions.createTeamCommissionsSuccess(response.data));
    InsighttNotification('success', 'Team Bonus was created successfully', response);
  } else {
    InsighttNotification('error', 'Unable to create Team Bonus', response);
    yield put(ShiftDetailsActions.createTeamCommissionsFailure());
  }
}

export function* updateTeamCommissionsRequest(api, action) {
  const { shiftId, payload } = action;
  const response = yield api.updateTeamCommissions(shiftId, payload);
  if (response && response.ok) {
    yield put(ShiftDetailsActions.updateTeamCommissionsSuccess(response.data));
    InsighttNotification('success', 'Team Bonus was updated successfully', response);
  } else {
    InsighttNotification('error', 'Unable to update Team Bonus', response);
    yield put(ShiftDetailsActions.updateTeamCommissionsFailure());
  }
}

export function* deleteTeamCommissionsRequest(api, action) {
  const { shiftId } = action;
  const response = yield api.deleteTeamCommissions(shiftId);
  if (response && response.ok) {
    yield put(ShiftDetailsActions.deleteTeamCommissionsSuccess());
    InsighttNotification('success', 'Team Bonus was removed successfully', response);
  } else {
    InsighttNotification('error', 'Unable to remove Team Bonus', response);
    yield put(ShiftDetailsActions.deleteTeamCommissionsFailure());
  }
}

export function* createPerVehicleCommissionsRequest(api, action) {
  const { shiftId, payload } = action;
  const response = yield api.createPerVehicleCommissions(shiftId, payload);
  if (response && response.ok) {
    yield put(ShiftDetailsActions.createPerVehicleCommissionsSuccess(response.data));
    InsighttNotification('success', 'Per Vehicle Commission was created successfully', response);
  } else {
    InsighttNotification('error', 'Unable to create Per Vehicle Commission', response);
    yield put(ShiftDetailsActions.createPerVehicleCommissionsFailure());
  }
}

export function* updatePerVehicleCommissionsRequest(api, action) {
  const { shiftId, payload } = action;
  const response = yield api.updatePerVehicleCommissions(shiftId, payload);
  if (response && response.ok) {
    yield put(ShiftDetailsActions.updatePerVehicleCommissionsSuccess(response.data));
    InsighttNotification('success', 'Per Vehicle Commission was updated successfully', response);
  } else {
    InsighttNotification('error', 'Unable to update Per Vehicle Commission', response);
    yield put(ShiftDetailsActions.updatePerVehicleCommissionsFailure());
  }
}

export function* deletePerVehicleCommissionsRequest(api, action) {
  const { shiftId } = action;
  const response = yield api.deletePerVehicleCommissions(shiftId);
  if (response && response.ok) {
    yield put(ShiftDetailsActions.deletePerVehicleCommissionsSuccess());
    InsighttNotification('success', 'Per Vehicle Commission was removed successfully', response);
  } else {
    InsighttNotification('error', 'Unable to remove Per Vehicle Commission', response);
    yield put(ShiftDetailsActions.deletePerVehicleCommissionsFailure());
  }
}
